import { render, staticRenderFns } from "./SuccessKits.vue?vue&type=template&id=88be8942"
import script from "./SuccessKits.vue?vue&type=script&lang=js"
export * from "./SuccessKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports